import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: transparent;\n\tbox-shadow: ", ";\n"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n\n\tinput:checked ~ & {\n\t\tbackground: ", ";\n\t\tborder-color: ", ";\n\t}\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-left: auto;\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: ", ";\n\theight: ", ";\n\twidth: ", ";\n\n\t*:active > & {\n\t\twidth: ", ";\n\t}\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: ", ";\n\theight: ", ";\n\twidth: ", ";\n\n\t*:active > & {\n\t\twidth: ", ";\n\t}\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: ", ";\n\tbox-shadow: ", ";\n\theight: ", ";\n\tpointer-events: none;\n\tright: initial;\n\ttransform: translate(0, 0);\n\ttransition: all ", " linear;\n\twidth: ", ";\n\n\t", "\n\n\t*:active > & {\n\t\twidth: ", ";\n\t}\n\n\tinput:checked ~ & {\n\t\tbackground: ", ";\n\t\tleft: initial;\n\t\tright: ", ";\n\t}\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tbox-shadow: ", ";\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\n\tbackground: ", ";\n\tborder: 1px solid ", ";\n\tbottom: ", ";\n\tbox-shadow: 0 0 0 0 rgba(0, 0, 0, 0);\n\tdisplay: block;\n\tleft: 0;\n\tpointer-events: none;\n\tpointer-events: none;\n\tposition: absolute;\n\ttop: ", ";\n\ttransition: all ", " linear;\n\twidth: 100%;\n\n\tinput:checked ~ & {\n\t\tbackground: ", ";\n\t\tborder-color: ", ";\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\topacity: 0;\n\tpadding: 0;\n\tposition: absolute;\n\tz-index: -1;\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: ", ";\n\twidth: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: ", ";\n\twidth: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\topacity: 0.6;\n\tpointer-events: none;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\tmargin: 0;\n\toutline: none;\n\tpadding: ", " 0;\n\tposition: relative;\n\tuser-select: none;\n\twidth: ", ";\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';

function getSwitchWidth(height) {
  return "calc(" + getControlHeight(height) + " * 1.85);";
}

export var Switch = css(_templateObject(), ui.get('controlHeight'), ui.get('switchPaddingOffset'), getSwitchWidth('controlHeight'));
export var disabled = css(_templateObject2());
export var large = css(_templateObject3(), ui.get('controlHeightLarge'), getSwitchWidth('controlHeightLarge'));
export var small = css(_templateObject4(), ui.get('controlHeightSmall'), getSwitchWidth('controlHeightSmall'));
export var inputHidden = css(_templateObject5());
export var Backdrop = css(_templateObject6(), ui.borderRadius.circle, ui.get('switchBackdropBackgroundColor'), ui.get('switchBackdropBorderColor'), ui.get('switchPaddingOffset'), ui.get('switchPaddingOffset'), ui.get('transitionDurationFast'), ui.get('switchBackdropBackgroundColorActive'), ui.get('switchBackdropBorderColorActive'));
export var focus = css(_templateObject7(), ui.get('controlPseudoBoxShadowFocus'));
export var Toggle = css(_templateObject8(), ui.get('switchToggleBackgroundColor'), ui.get('switchToggleBorderColor'), getToggleHeight('controlHeight'), ui.get('switchToggleBoxShadow'), getToggleHeight('controlHeight'), ui.get('transitionDurationFast'), getToggleHeight('controlHeight'), getTogglePosition(), getControlHeight('controlHeight'), ui.get('switchToggleBackgroundColorActive'), getTogglePositionX());
export var toggleLarge = css(_templateObject9(), getToggleHeight('controlHeightLarge'), getToggleHeight('controlHeightLarge'), getToggleHeight('controlHeightLarge'), getControlHeight('controlHeightLarge'));
export var toggleSmall = css(_templateObject10(), getToggleHeight('controlHeightSmall'), getToggleHeight('controlHeightSmall'), getToggleHeight('controlHeightSmall'), getControlHeight('controlHeightSmall'));
export var formGroup = css(_templateObject11());
export var backdropError = css(_templateObject12(), ui.get('controlDestructiveBorderColor'), ui.get('controlDestructiveBorderColor'), ui.get('controlDestructiveBorderColor'));
export var backdropErrorFocus = css(_templateObject13(), ui.get('controlDestructivePseudoBoxShadowFocus'));

function getControlHeight(height) {
  return "calc(" + ui.get(height) + " - calc(" + ui.get('switchPaddingOffset') + " * 2))";
}

function getToggleHeight(height) {
  return "calc(" + getControlHeight(height) + " - " + ui.get('switchPaddingOffset') + ")";
}

function getTogglePosition() {
  var value = "calc(" + ui.get('switchPaddingOffset') + " * 2)";
  var left = getTogglePositionX();
  return css({
    top: "calc(" + value + " * 0.75)",
    left: left,
    position: 'absolute'
  });
}

function getTogglePositionX() {
  var value = "calc(" + ui.get('switchPaddingOffset') + " * 2)";
  return "calc(" + value + " * 0.25)";
}